export enum FamilyStatusProblemType {
  CeoChairmanMissingFamilyStatus = 1,
  FamilyOccupationMismatch = 2,
  OccupationFamilyStatusMismatch = 3,
  IndependentWithFamilyStatus = 4,
  FamilyGenerationMismatch = 5
}
